// src/pages/news/ClinicLocationInfo.js
import React from 'react';
import { Link } from 'react-router-dom';
import './ClinicLocationInfo.css';

const ClinicLocationInfo = () => {
  return (
    <div className="clinic-location-info">
      <div className="container">
        <div className="info-card">
          <div className="info-header">
            <div className="info-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h1>New Feature: Clinic Location</h1>
            <div className="feature-badge">NEW</div>
          </div>
          
          <div className="info-content">
            <div className="feature-description">
              <h2>Set Your Clinic Location</h2>
              <p>
                You can now add your clinic's location information to your profile! 
                This new feature allows you to provide detailed location information 
                that will be displayed on your public profile page.
              </p>
            </div>

            <div className="benefits-section">
              <h3>Benefits:</h3>
              <ul className="benefits-list">
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Help patients find your clinic easily</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Display professional location information</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Improve your online presence</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Build trust with potential patients</span>
                </li>
              </ul>
            </div>

            <div className="how-to-section">
              <h3>How to Set Your Location:</h3>
              <div className="steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Go to Your Profile</h4>
                    <p>Navigate to the Profile page from the main menu</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>Find Clinic Information Section</h4>
                    <p>Scroll down to the "Clinic Information" section</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Add Your Location</h4>
                    <p>Fill in your clinic's address and location details</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h4>Save Changes</h4>
                    <p>Click "Update Information" to save your location</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="action-buttons">
              <Link to="/control/doctor-information" className="primary-btn">
                <i className="fas fa-user-md"></i>
                Go to Profile
              </Link>
              <Link to="/control/appointments" className="secondary-btn">
                <i className="fas fa-arrow-left"></i>
                Back to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClinicLocationInfo;
